import React, {PureComponent} from 'react'
import {withSource} from 'src/CheckSources'

import DataExplorer from './DataExplorer'

import {ErrorHandling} from 'src/shared/decorators/errors'

import {Source} from 'src/types'

interface Props {
  source: Source
}

class DataExplorerPage extends PureComponent<Props> {
  public render() {
    return (
      <div className="page">
        <DataExplorer source={this.props.source} />
      </div>
    )
  }
}

export default withSource(ErrorHandling(DataExplorerPage))
